<template>
  <div class="address">
    <el-dialog
      :title="`${!!params.addr_id ? pc_lang['EditAddress'] : pc_lang['AddAddress']}`"
      :visible.sync="addressPopBoolean"
      width="40%"
      :close-on-click-modal="false"
      :before-close="handleClose">

      <div class="row">
        <el-input class="item1" v-model="params.first_name"  size="small" :placeholder="pc_lang['First_name']"></el-input>
        <el-input class="item1" v-model="params.last_name"  size="small" :placeholder="pc_lang['Last_name']"></el-input>
      </div>

      <div class="row">
        <el-input class="item1" v-model="params.gr"  size="small" :placeholder="`${pc_lang['Country_code']} +60`"></el-input>
        <el-input class="item1" v-model="params.mobile"  size="small" :placeholder="pc_lang['Tel']"></el-input>
        <el-input class="item1" v-model="params.email"  size="small" :placeholder="pc_lang['Email_address']"></el-input>
      </div>

      <div class="row">
        <el-input class="item1" v-model="params.country"  size="small" :placeholder="pc_lang['Country']"></el-input>
        <el-input class="item1" v-model="params.province"  size="small" :placeholder="pc_lang['Province']"></el-input>
        <el-input class="item1" v-model="params.city"  size="small" :placeholder="pc_lang['City']"></el-input>
        <el-input class="item2" v-model="params.address"  size="small" :placeholder="pc_lang['Detailed_address']"></el-input>
        <el-input class="item3" v-model="params.zip"  size="small" :placeholder="pc_lang['Zip']"></el-input>
      </div>


      <span slot="footer" class="dialog-footer">
        <el-checkbox size="small" v-model="params.is_default" :true-label="1" :false-label="0">{{ pc_lang['Set_default'] }}</el-checkbox>
        <el-button size="small" @click="handleCloseA">{{ pc_lang['Cancel'] }}</el-button>
        <el-button size="small" type="primary" @click="submit">{{ pc_lang['Confirm'] }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import * as API_ADDRESS from '@/api/address'
import * as RegExp from '@/utils/RegExp'

export default {
  name: 'UserAddressPop',
  components: {

  },
  props: {
    addressPopBoolean: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: ()=> {
        return {
          first_name: '',
          last_name: '',
          country: '',
          province: '',
          city: '',
          address: '',
          zip: '',
          gr: '',
          mobile: '',
          email: '',
          is_default: '',
          addr_id: ''
        }
      }
    }
  },
  data() {
    return {
      // 地址信息
      // params: {
      //   first_name: '',
      //   last_name: '',
      //   country: '',
      //   province: '',
      //   city: '',
      //   address: '',
      //   zip: '',
      //   gr: '',
      //   mobile: '',
      //   email: '',
      //   is_default: '',
      //   addr_id: ''
      // }
    }
  },
  computed: {

  },
  async mounted() {

  },
  created() {

  },
  methods: {
    handleClose(done) {
      // return false
      // done()
      this.$parent.addressPopBoolean = false
    },
    handleCloseA() {
      this.$parent.addressPopBoolean = false
    },
    add(params) {
      API_ADDRESS.addAddress(params).then(res=> {
        this.$parent.addressPopBoolean = false
        this.$emit('submit', this.params)
      })
    },
    edit(params) {
      API_ADDRESS.editAddress(params).then(res=> {
        this.$parent.addressPopBoolean = false
        this.$emit('submit', this.params)
      })
    },
    submit() {
      // 验证全都有填写
      let fill_all = true
      const { addr_id, is_default, ...requiredInfo } = this.params
      for( let k in requiredInfo ) {
        if ( this.params[k] == '' ) {
          fill_all = false
        }
      }
      if ( !fill_all ) {
        this.$message.error('请完善信息！')
        return false
      }
      // 验证邮箱格式
      if ( !RegExp.email.test(this.params.email) ) {
        this.$message.error('请填写正确的邮箱！')
        return false
      }

      this.params.gr = this.params.gr.trim()
      if ( this.params.gr.search(/\+/) !== 0 ) {
        this.params.gr = '+' + this.params.gr
      }

      if (!!this.params.addr_id) {
        this.edit(this.params)
      } else {
        this.add(this.params)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.address{
  .row{
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 12px;
    &:last-child{
      margin-bottom: 0;
    }
    .item1{
      width: 180px;
      margin-right: 16px;
    }
    .item2{
      width: 456px;
      margin-top: 12px;
      margin-right: 16px;
    }
    .item3{
      width: 100px;
      margin-top: 12px;
      margin-right: 16px;
    }
  }
  ::v-deep.el-dialog__body{
    padding: 12px 20px;
  }
}
.dialog-footer{
  .el-checkbox{
    margin-right: 16px;
  }
}
</style>